/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".campaign-view-label[_ngcontent-%COMP%]{font-weight:700;padding-right:.3em;float:left;margin-bottom:0}.label-min-height[_ngcontent-%COMP%]{min-height:21px}.campaign-view-promo-header[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{margin-top:0;padding-right:10px}@media (max-width:767.98px){.main-promo-card[_ngcontent-%COMP%]{padding-left:0;padding-right:0}}.status[_ngcontent-%COMP%]{font-size:.95em}.in-progress[_ngcontent-%COMP%]{color:#e07979}.completed[_ngcontent-%COMP%]{color:#7bbe7b}"];
export { styles as styles };
